
import Navbar from "../components/Navbar";
import SecondNavbar from "../components/SecondNavbar";
import Footer from "../components/Footer";
import ProtectedWrapper from "../components/ProtectedWrapper";
import EventContent from "./EventContent";

// ======================================================
// EVENT PAGE
// ======================================================

const Event = () => {
  return (
    <>
      <Navbar />

      <SecondNavbar />

      <ProtectedWrapper
        isLoggedIn={!!localStorage.getItem("token")}
      >
        <EventContent />
      </ProtectedWrapper>

      <Footer />
    </>
  );
};

export default Event;

